import { Entry } from '../Entry'

export function Entry20261104() {
  return (
    <Entry title="2026 Nov 4 - v3.11.23">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/27290/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
